var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5335_4131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.625C3.925 0.625 0.625 3.925 0.625 8C0.625 12.075 3.925 15.375 8 15.375C12.075 15.375 15.375 12.075 15.375 8C15.375 3.925 12.075 0.625 8 0.625ZM7.9875 14.1313C4.59375 14.1313 1.84375 11.3813 1.84375 7.98125C1.84375 4.5875 4.59375 1.8375 7.9875 1.8375C11.3813 1.8375 14.1313 4.5875 14.1313 7.98125C14.1375 11.3813 11.3875 14.1313 7.9875 14.1313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4626 5.09375C11.2751 5.09375 11.1063 5.18125 10.9938 5.3125L6.8876 9.4125L4.98135 7.50625C4.86885 7.3875 4.7126 7.3125 4.53135 7.3125C4.1876 7.3125 3.9126 7.5875 3.9126 7.93125C3.9126 8.10625 3.9876 8.26875 4.10635 8.38125L6.00635 10.2812L6.4126 10.6875C6.5251 10.8125 6.69385 10.8938 6.8751 10.8938C7.0501 10.8938 7.20635 10.8188 7.31885 10.7063L11.8438 6.18125C11.9813 6.06875 12.0751 5.89375 12.0751 5.7C12.0813 5.36875 11.8063 5.09375 11.4626 5.09375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5335_4131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submit-icon.d2694fafddab9aced31e4d9307212f43.svg";
export { ForwardRef as ReactComponent };